import { Injectable } from '@angular/core';
import { SharedQueryEntity } from 'libs/api/akita-query';
import { FileUploadInfo } from './file.model';
import { FileState, FileStore, FileUIState } from './file.store';

@Injectable({ providedIn: 'root' })
export class FileQuery extends SharedQueryEntity<FileUploadInfo, FileState, FileUIState> {
  isLoading$ = this.selectLoading();

  constructor(protected override store: FileStore) {
    super(store);
    this.createUIQuery();
  }

  getFiles(fileIds: string[]) {
    return this.getAll({ filterBy: entity => fileIds.includes(entity.fileId) });
  }
}
